<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div class="row">
            <div class="col-md-12">
                <b-alert v-if="!loading && areRequiredGroups && hasGroup(cfg.requiredGroups)" show variant="success">
                    <i class="fa fa-check mr-2"></i> Posiadasz wymagane grupy, aby zarządzać rangami
                </b-alert>
                <b-alert v-else-if="!loading && areRequiredGroups" show variant="danger">
                    <i class="fa fa-times mr-2"></i> Aby zmienić sobie grupy musisz mieć co najmniej jedną wymaganą grupę:
                    <div class="d-flex flex-row">
                        <server-group v-for="group in cfg.requiredGroups" :key="group.sgid" :group="group" :withName="true"/>
                    </div>
                </b-alert>
            </div>
        </div>
        <div class="row" :key="key">
            <div
                v-for="(section, sectionName, index) of cfg.zones"
                  :key="sectionName"
                  class="col-xl-4 col-lg-6"
            >
                <div class="card">
                    <div class="card-header">
                        <h3><i v-if="section.icon" :class="section.icon"></i> {{ sectionName }}</h3>
                        <h6>Limit: {{ section.limit }}</h6>
                    </div>
                    <div class="card-body">
                        <select-server-groups :groups="section.groups" :limit="section.limit" :ref="'select-' + index"/>
                    </div>
                    <div class="card-footer d-flex justify-content-center">
                        <button
                            class="btn btn-primary"
                            @click="handleSave(index)"
                            :disabled="areRequiredGroups && !hasGroup(cfg.requiredGroups)"
                        ><i class="fa fa-check"></i> Zapisz
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import GroupsService from "@/services/groups.service";
import {
    notificationMethods
} from "@/state/helpers";
import {
    hasGroup
} from "@/helpers/helper"

/**
 * Starter component
 */
export default {
    name: "Groups",
    components: {Layout, PageHeader},
    data() {
        return {
            title: "Zmiana grup",
            items: [
                {
                    text: "Konto",
                    href: "/"
                },
                {
                    text: "Zmiana grup",
                    active: true
                }
            ],
            loading: true,
            cfg: {},
            key: 1
        };
    },
    computed: {
        isRegistered() {
            return this.$store.getters['auth/user'].isRegistered;
        },
        groupsCfg() {
            return this.$store.getters['cfg/get'].panel.groups;
        },
        areRequiredGroups() {
            return this.cfg.requiredGroups && this.cfg.requiredGroups.length > 0;
        }
    },
    watch: {
        isRegistered() {
            this.checkRegistration();
        }
    },
    beforeMount() {
        this.checkRegistration();
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ... notificationMethods,
        hasGroup: hasGroup,
        checkRegistration() {
            if (this.groupsCfg.requiredRegistration && !this.isRegistered) {
                this.error('Najpierw się zarejestruj!');
                this.$router.push({ name: 'account.registration'});
            }
        },
        loadData() {
            GroupsService.getData().then(
                response => {
                    this.cfg = response.data;
                    this.key++;
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        handleSave(index) {
            if (this.areRequiredGroups && !hasGroup(this.cfg.requiredGroups))
                return;

            this.loading = true;
            let groups = this.$refs['select-' + index][0].getSelected();

            if (groups.length > 0)
                groups = groups.map(g => g.sgid)
            else
                groups = null;

            GroupsService.change(index, groups).then(
                () => {
                    this.success("Grupy zostały zmienione");
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loadData();
                }
            )
        }
    }
};
</script>